// extracted by mini-css-extract-plugin
export var item = "Team-module--item--f075f";
export var items = "Team-module--items--4c2b4";
export var section = "Team-module--section--fcb8f";